import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sendContactUs } from "../../actions/BusinessUserActions";
import PhoneInputBox from "../../components/InputBox/PhoneInputBox";
import AppConfig from "../../config";
import ContactMain from "../ContactMain/ContactMain";
import InputBox from "../InputBox/InputBox";
import OpenTime from "../OpenTime/OpenTime";
import SelectBox from "../SelectBox/SelectBox";
import TextArea from "../TextArea/TextArea";
import "./ContactUs.scss";

const API_URL = AppConfig.API_URL;

// const mailOptions = [
//   {
//     label: "Kontakt Gruppenpraxis Neuhard",
//     value: "vishalini.varda@wensdigital.com",
//   },
//   {
//     label: "Kontakt Physiotherapie",
//     value: "vishalini.varda@wensdigital.com"
//   },
// ];

const mailOptions = [
  {
    label: "Kontakt Gruppenpraxis Neuhard",
    value: "gruppenpraxis.neuhard@hin.ch",
  },
  {
    label: "Kontakt Physiotherapie",
    value: "physio.regula.schneider@bluewin.ch",
  },
];
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      mobile: "",
      message: "",
      validateFields: [],
      isSubmit: false,
      mailType: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  onchangeText = (value, type) => {
    this.setState({ [type]: value });
  };

  onSend = () => {
    const { mailType, name, email, mobile, message } = this.state;
    let flag = true;
    const validation = this.state.validateFields.map((data) => {
      if (!data.isValid) {
        flag = false;
      }
      if (!data.isValid && !data.message && !data.notMandatory) {
        const labelVal = data.key.charAt(0).toUpperCase() + data.key.slice(1);
        const lab = labelVal.split(/(?=[A-Z])/).join(" ");
        data["message"] = lab;
        data["message1"] = "is required";
        return data;
      } else {
        return data;
      }
    });
    if (flag) {
      this.props.dispatch(
        sendContactUs(
          { mailType, name, email, mobile, message },
          this.clearUserData
        )
      );
    }
    this.setState({ validateFields: validation, isSubmit: true });
  };

  clearUserData = () => {
    toast.info(
      this.props.loadTranslations("Message Sent", this.props.currentLanguage)
    );
    const validateFieldsRefresh = this.state.validateFields.map((data) => {
      data.isValid = false;
      return data;
    });
    this.setState({
      isSubmit: false,
      validateFields: validateFieldsRefresh,
      name: "",
      email: "",
      mobile: "",
      message: "",
    });
  };

  errorFn = (fields) => {
    this.setState({ validateFields: fields });
  };
  render() {
    // window.onscroll = function () { myFunction() };
    // function myFunction() {
    //   if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
    //     document.getElementById("contact-section").className = "contact-section contact-page-section padding-top-120 active";
    //   } else {
    //     document.getElementById("contact-section").className = "contact-section contact-page-section padding-top-120";
    //   }
    // }
    return (
      <div>
        <ToastContainer hideProgressBar={true} position="bottom-right" />
        <div className="contactus-wrap blogs-graphic">
          <section
            className="page-top-banner contact-banner section-gap-full relative"
            data-stellar-background-ratio="0.5"
            style={{ padding: "0" }}
          >
            <div className="overlay overlay-bg" />
            <div className="container">
              <Row>
                <Col className="col-lg-12">
                  <div>
                    <h1 style={{ marginTop: "0" }}>
                      {this.props.loadTranslations(
                        "KONTAKT",
                        this.props.currentLanguage
                      )}
                    </h1>
                  </div>
                </Col>
              </Row>
            </div>
          </section>
          <section
            className="contact-section contact-page-section section-gap-half active section-gap-45"
            style={{ fontSize: "15px" }}
            id="contact-section"
          >
            <div className="container">
              <Row>
                <Col lg={2} md={2} sm={1} xs={12} />
                <Col lg={8} md={8} sm={10} xs={12}>
                  <div className="justify-content-center form-row blogs-post-column">
                    <div className="full-width">
                      <div id="contact-form" action="#">
                        <div className="row contact-form-wrap justify-content-center">
                          <div
                            style={{ padding: 5 }}
                            onMouseLeave={() =>
                              this.setState({ errorFlag: "", errMessage: "" })
                            }
                          >
                            <Row>
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="contact-name form-col"
                              >
                                <SelectBox
                                  placeholder={"Mail Typ"}
                                  isSubmit={this.state.isSubmit}
                                  validateFields={this.state.validateFields}
                                  options={mailOptions}
                                  errorFn={this.errorFn}
                                  id={"mailType"}
                                  value={this.state.mailType}
                                  onchangeText={this.onchangeText}
                                />
                              </Col>
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="contact-name form-col"
                              >
                                <InputBox
                                  placeholder="Name"
                                  // label={"Name"}
                                  isSubmit={this.state.isSubmit}
                                  validateFields={this.state.validateFields}
                                  mandatory={true}
                                  length={200}
                                  value={this.state.name}
                                  errorFn={this.errorFn}
                                  id="name"
                                  onChange={this.onchangeText}
                                />
                              </Col>
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className=" contact-name form-col"
                              >
                                <InputBox
                                  placeholder="E-Mail-Addresse"
                                  // label={"Email"}
                                  isSubmit={this.state.isSubmit}
                                  fieldType={"email"}
                                  validateFields={this.state.validateFields}
                                  mandatory={true}
                                  length={100}
                                  value={this.state.email}
                                  errorFn={this.errorFn}
                                  id="email"
                                  onChange={this.onchangeText}
                                />
                              </Col>
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className=" contact-name form-col"
                              >
                                <PhoneInputBox
                                  placeholder={"Handy Nummer"}
                                  isSubmit={this.state.isSubmit}
                                  validateFields={this.state.validateFields}
                                  errorFn={this.errorFn}
                                  id="mobile"
                                  value={this.state.mobile}
                                  onChange={this.onchangeText}
                                />
                              </Col>
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className=" contact-name form-col"
                              >
                                <TextArea
                                  placeholder={
                                    "Nachricht (Maximal 1000 Zeichen)"
                                  }
                                  // label={"Message"}
                                  isSubmit={this.state.isSubmit}
                                  validateFields={this.state.validateFields}
                                  errorFn={this.errorFn}
                                  length={1000}
                                  value={this.state.message}
                                  id="message"
                                  onChange={this.onchangeText}
                                  minHeight={200}
                                  style={{ minHeight: 200 }}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className=" contact-name form-col"
                              >
                                *Keine Terminvergabe per E-Mail
                              </Col>
                            </Row>
                            <Row>
                              <Col
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="text-center"
                              >
                                <Button
                                  type="submit"
                                  value="Login"
                                  className="btn btn-ellipse emergency-bttn btn btn-default"
                                  onClick={this.onSend}
                                >
                                  {this.props.loadTranslations(
                                    "NACHRICHT SENDEN",
                                    this.props.currentLanguage
                                  )}
                                </Button>
                              </Col>
                            </Row>
                          </div>
                          {/* <input type="submit" className="" value="Send Message" id="submit-message" /> */}
                          <div id="msg" className="message"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col lg={2} md={2} sm={1} xs={12} />
                {/* <Col lg={4} md={4} sm={6} xs={12} className="CDetails">
                <div>
                  <h6>Social</h6>
                  <hr className="text-subline" />
                  <div>
                    <ul className="social-list">
                      <li>
                        <i className="fab fa-facebook-f" />
                      </li>
                      <li>
                        <i className="fab fa-twitter" />
                      </li>
                      <li>
                        <i className="fab fa-linkedin-in" />
                      </li>
                      <li>
                        <i className="fab fa-instagram" />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="offset-top-30">
                  <h6>ADDRESS</h6>
                  <hr className="text-subline" />
                  <Row>
                    <Col lg={2} md={2} sm={3} xs={6} className="no-padding">
                      <i className="fas fa-map-marker-alt loca-ico" />
                    </Col>
                    <Col lg={9} md={9} sm={8} xs={12}>
                      {" "}
                      Neuhardstr. 38, 46000 Olten, Switzerland
                    </Col>
                  </Row>
                </div>
                <div className="offset-top-30">
                  <h6>PHONES</h6>
                  <hr className="text-subline" />
                  <Row>
                    <Col lg={2} md={2} sm={3} xs={6} className="no-padding">
                      <i className="fas fa-phone loca-ico" />
                    </Col>
                    <Col lg={9} md={9} sm={8} xs={12}>
                      <p>062 296 50 55</p>
                      <p>062 296 06 97</p>
                    </Col>
                  </Row>
                </div>
                <div className="offset-top-30">
                  <h6>E-Mail</h6>
                  <hr className="text-subline" />
                  <Row>
                    <Col lg={2} md={2} sm={3} xs={6} className="no-padding">
                      <i class="fas fa-envelope loca-ico" />
                    </Col>
                    <Col lg={9} md={9} sm={8} xs={12}>
                      <p>gruppenpraxis.neuhard@hin.ch</p>
                      <p>physio.regula.schneider@bluewin.ch</p>
                    </Col>
                  </Row>
                </div>
              </Col> */}
              </Row>
            </div>
          </section>

          {/* <Emergency /> */}
          <OpenTime />
          <ContactMain />
          {/* <Tabs defaultActiveKey="contactform" id="uncontrolled-tab-example" mountOnEnter={true} unmountOnExit={true}>
                <Tab eventKey="contactform" title={this.props.loadTranslations('Contact Us', this.props.currentLanguage)}>
                    <Row>
                        <Col lg={8} md={6} sm={6} xs={12} lgOffset={2} mdOffset={3} smOffset={3} className="no-padding">
                            <ToastContainer hideProgressBar={true} position="bottom-right" />
                            <div style={{ backgroundColor: '#f6f8fa' }} >
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="padding-5">
                                        <center>
                                            <div className="login-text">{this.props.loadTranslations('Contact Us', this.props.currentLanguage)}</div>
                                            <br />
                                        </center>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ backgroundColor: '#edf0f3', padding: 5 }} onMouseLeave={() => this.setState({ errorFlag: '', errMessage: '' })}>
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="registration-padding">
                                        <InputBox label={'Name'} isSubmit={this.state.isSubmit} validateFields={this.state.validateFields} mandatory={true} length={200} value={this.state.name} errorFn={this.errorFn} id="name" onChange={this.onchangeText} />
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="registration-padding">
                                        <InputBox label={'Email'} isSubmit={this.state.isSubmit} fieldType={'email'} validateFields={this.state.validateFields} mandatory={true} length={100} value={this.state.email} errorFn={this.errorFn} id="email" onChange={this.onchangeText} />
                                    </Col>
                                    <Col lg={12} md={12} sm={12} xs={12} className="registration-padding">
                                        <TextArea placeholder={'Maximum 1000 characters'} label={'Message'} isSubmit={this.state.isSubmit} validateFields={this.state.validateFields} errorFn={this.errorFn} length={1000} value={this.state.message} id="message" onChange={this.onchangeText} minHeight={200} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="padding-10">
                                        <button style={{ height: '35px', width: '100%', backgroundColor: '#0984e3', color: '#ffffff', borderRadius: 5 }} type="submit" value="Login" className="loginButton" onClick={this.onSend}>
                                            {this.props.loadTranslations('Send Message', this.props.currentLanguage)}
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="map" title={this.props.loadTranslations('Contact Map', this.props.currentLanguage)}>
                    <Mapbox {...this.props} />
                </Tab>
            </Tabs> */}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.users.currentLanguage,
  };
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./screens/ContactUs/ContactUs.js